<template>
    <div class="card mt-2" style="margin-bottom:10px">

        <div class=" card-body">

            <div class="row">
                <!-- Imagen de perfil -->
                <div class="col-md-3 d-flex justify-content-center align-items-center mb-2">
                    <div class="profile-img">
                        <span class="profile-initials">{{ infoPaciente.iniciales }}</span>
                    </div>
                </div>

                <!-- Información del paciente -->
                <div class="col-md-9 mb-2">
                    <div class="card-container info-paciente">
                        <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
                            <span>INFORMACIÓN DEL PACIENTE</span>
                            <i class="bi bi-pencil-square"></i>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>Nombres y apellidos: </strong>{{ infoPaciente.displayName }} {{
                                        infoPaciente.lastName }}</p>
                                    <p><strong>Edad: </strong>{{ infoPaciente.edad }}</p>
                                    <p><strong>Tipo de Identificación: </strong> {{ infoPaciente.tipoCiudadano }}</p>
                                    <p><strong>Identificación: </strong> {{ infoPaciente.identificacion }}</p>
                                    <p><strong>Sexo: </strong> {{ infoPaciente.sexo }}</p>
                                    
                                </div>
                                <div class="col-md-6">
                                    <p><strong>Estado civil: </strong> {{ infoPaciente.estado_civil }}</p>
                                    <p><strong>Fecha nacimiento:</strong> {{ infoPaciente.fech_nacimiento }}</p>
                                    <p><strong>E-mail:</strong> {{ infoPaciente.email }}</p>
                                    <p><strong>Celular:</strong> {{ infoPaciente.celular }}</p>
                                    <p><strong>Ocupación:</strong> {{ infoPaciente.ocupacion }}</p>
                                    <p><strong>Fecha de registro:</strong> {{ infoPaciente.fecha_registro }}</p>
                                </div>

                            </div>


                        </div>

                    </div>


                </div>





            </div>





            <div class="row">



                <signos-vitales />

            </div>

        </div>
    </div>
</template>

<script>
/* eslint-disable */
import SignosVitales from './SignosVitales.vue';

export default {
    name: "Perfil-Paciente",
    props: {
        enviarsend: {
            type: Object,
            required: false
        }
    },
    components: {
        SignosVitales
    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,
            infoPaciente: {
                displayName: '',
                lastName: '',
                iniciales: '',
                edad: '',
                tipoCiudadano: '',
                identificacion: '',
                sexo: '',
                estado_civil: '',
                fech_nacimiento: '',
                email: '',
                celular: '',
                ocupacion: '',
                fecha_registro: ''

            },

        };
    },
    computed: {},
    watch: {},

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.cargaDatosPaciente()

    },
    methods: {
        cargaDatosPaciente() {
            this.$https.post('/consulta/getLoadPacienteId', { codigoId: this.$route.params.id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (response.data.code === 200) {

                    let resp = response.data.datos[0]

                    //this.infoPaciente
                    this.infoPaciente.displayName = resp.nombres
                    this.infoPaciente.lastName = resp.apellidos
                        this.infoPaciente.edad = this.calcularEdad(resp.nacimiento)
                        this.infoPaciente.tipoCiudadano = resp.tipo_identificacion
                        this.infoPaciente.identificacion = resp.cedula
                        this.infoPaciente.iniciales = resp.nombres.charAt(0) + resp.apellidos.charAt(0)
                        this.infoPaciente.sexo = resp.sexo
                        this.infoPaciente.estado_civil = resp.estado_civil
                        this.infoPaciente.fech_nacimiento = resp.nacimiento
                        this.infoPaciente.email = resp.correo
                        this.infoPaciente.celular = resp.celular
                        this.infoPaciente.ocupacion = resp.ocupacion
                        this.infoPaciente.fecha_registro = resp.created_at

                }


            }).catch(error => {



                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`, // Usa HTML para darle formato
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }


                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert()
                }



            })
        }
    }

}



</script>

<style scoped>
.profile-img {
    width: 160px;
    height: 160px;
    background-color: #cce5ff;
    border-radius: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    font-weight: bold;
    color: #0078be !important;
    border: 5px solid white;
    position: relative;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}

.profile-initials {
    text-transform: uppercase;
}

.card-header {
    font-weight: bold;
    background: #0078be !important;
}

.info-paciente .card-header {
    padding: 8px 14px;
    font-size: 13px;
}

.info-paciente .card-body {
    padding: 10px 14px 8px;
}

.info-paciente p {
    margin: 0 0 6px;
    line-height: 1.35;
    font-size: 13px;
}

.card-container {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
    /* transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out; */
}

/* .card-container:hover {
    transform: translateY(-5px);
    box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.3);
} */
</style>